import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { cleanOfferShoppingCart } from '../../../../apollo/helpers/shopping-cart';
import { shoppingCartOffersVar } from '../../../../apollo/reactive-variables/shopping-cart';
import ShoppingCartSummaryActionButton from '../../ShoppingCartSummary/ShoppingCartSummaryActionButton';
import { PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME } from '../../../../theme/constants/stack';
import { CONFIRMATION_ICON_CLASS_NAME } from '../../../../theme/constants/icon';

const ConfirmationStep = ({ toggleMenu, WarningComponent, warningComponentProps }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { branding } = useTheme();

  const cleanShoppingCart = () => {
    cleanOfferShoppingCart();
    shoppingCartOffersVar([]);
  };

  const handleConfirmation = () => {
    toggleMenu();
    cleanShoppingCart();
    history.push('/app/sales/factoring/current');
  };

  useEffect(
    // Cleanup: when component unmounts, clean the shopping cart
    // This prevents the user from going back to an inconsistent state
    () => () => {
      cleanShoppingCart();
    },
    [],
  );

  return (
    <Stack flexGrow={1} alignItems="center" justifyContent="space-between" spacing={2}>
      <Typography variant="h5" align="center" width="100%" paddingX={3}>
        {t('operation-confirmation-subtitle')}
      </Typography>
      <branding.icons.confirmation svgWrapperClassName={PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME} className={CONFIRMATION_ICON_CLASS_NAME} sx={{ fontSize: '170px' }} />
      {WarningComponent && (
        <WarningComponent {...warningComponentProps} />
      )}
      <ShoppingCartSummaryActionButton
        id="operation-confirmation-button"
        label={(
          <Typography variant="small_3" color="white" fontWeight={600}>
            {t('operation-confirmation-button-label')}
          </Typography>
      )}
        size="small"
        onClick={handleConfirmation}
      />
    </Stack>
  );
};

ConfirmationStep.propTypes = {
  toggleMenu: PropTypes.func,
  WarningComponent: PropTypes.elementType,
  warningComponentProps: PropTypes.shape({}),
};

ConfirmationStep.defaultProps = {
  toggleMenu: null,
  WarningComponent: null,
  warningComponentProps: {},
};

export default ConfirmationStep;
